export enum ContentType {
  Questions = "questions",
  Solutions = "solutions",
  Comments = "comments",
  Articles = "articles",
  InterviewGuides = "interview_guides",
  LearningPaths = "learning_paths",
  Companies = "companies",
  InterviewExperiences = "interview_experiences",
}

export const ContentTypeLabels: Record<ContentType, string> = {
  [ContentType.Questions]: "Question",
  [ContentType.Solutions]: "Solution",
  [ContentType.Comments]: "Comment",
  [ContentType.Articles]: "Blog Article",
  [ContentType.InterviewGuides]: "Interview Guide",
  [ContentType.LearningPaths]: "Learning Path",
  [ContentType.Companies]: "Company",
  [ContentType.InterviewExperiences]: "Interview Experience",
};

export const ContentTypePluralLabels: Record<ContentType, string> = {
  [ContentType.Questions]: "Questions",
  [ContentType.Solutions]: "Solutions",
  [ContentType.Comments]: "Comments",
  [ContentType.Articles]: "Blog Articles",
  [ContentType.InterviewGuides]: "Interview Guides",
  [ContentType.LearningPaths]: "Learning Paths",
  [ContentType.Companies]: "Companies",
  [ContentType.InterviewExperiences]: "Interview Experiences",
};

export const searchableContentTypes: ContentType[] = [
  ContentType.Questions,
  ContentType.InterviewGuides,
  ContentType.LearningPaths,
  ContentType.Articles,
];
